import { fetchKoumutenListAPI } from '../../api/fetch-functions/koumuten';
import { IKoumutenType } from '../../types/record/koumuten';
import {
  fetchListFnGenerator,
  fetchSignalStreamGenerator,
  listStreamGenerator
} from './common/zero-id-list';

const fetchSignal$ = fetchSignalStreamGenerator();

/**
 * @description
 * `fetchKoumutenList()` を実行すると `koumutenList$` が発火する．
 */
export const fetchKoumutenList = fetchListFnGenerator(fetchSignal$);

export const koumutenList$ = listStreamGenerator<IKoumutenType>(
  fetchSignal$,
  fetchKoumutenListAPI
);
